import React from 'react';

function NumberLoading(props) {
    return (
        <div className={"loader-number " + (props.inline ? "inline": "")}>
            <span>.</span>
            <span>.</span>
            <span>.</span>
            {props.postfix}
        </div>
    );
}

export default NumberLoading;
